//  Name: verify
import { LOGO, TW, FB, IN } from '@/config'
export default {
  data () {
    return {
      logo: LOGO,
      message: null,
      status: false,
      social: {
        twitter: TW,
        facebook: FB,
        linkedin: IN
      }
    }
  },
  mounted () {
    var vm = this
    var code = this.$route.params.code
    vm.message = '<i class="fa fa-spin fa-spinner"></i> Validando...'
    vm.$http.get('users/activate/' + code +'/')
    .then(response => {
      if (response.body.status === 'ok') {
        vm.status = true
      }
      vm.message = response.body.message
    }, error => {
      vm.message = 'Código inválido'
      console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/verify/script.js